module.exports = __webpack_public_path__ + "img/icon-product-w.8b7e40f6.svg";